import * as React from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody, Typography, makeStyles } from '@material-ui/core';
import { useIifImportSelector, IifImportSelectors } from '../store/modules/iifImport';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-duotone-svg-icons/faChevronDown';
import BillView from './BillView';
import AudCurrencyFormatter from '../utilities/currencyFormatter';
import { useApplicationSettingsSelector, ApplicationSettingsSelectors, TaxMode } from '../store/modules/applicationSettings';
import * as Dtos from '../api/dtos';

interface IBillViewsProps {
    fileIndex: number;
    billView: number[];
    amount: number;
    tax: number;
    total: number;
    errors?: Dtos.ResponseError[];
}

const useStyles = makeStyles(theme => ({
    expandCell: {
        width: 75
    },
    indexCell: {
        width: 75
    },
    dateCell: {
        width: 120
    },
    referenceCell: {
        width: 220
    },
    currencyCell: {
        width: 150
    },
    amountCell: {
        width: 150
    },
    totalCell: {
        fontWeight: 'bold'
    },
    totalAmountCell: {
        fontWeight: 'bold'
    },
    hiddenCell: {
        border: 'none'
    },
    title: {
        marginTop: theme.spacing(4)
    }
}))

const BillViews: React.FunctionComponent<IBillViewsProps> = ({
    fileIndex,
    billView,
    amount,
    tax,
    total,
    errors
}) => {
    const classes = useStyles();

    const taxMode = useApplicationSettingsSelector(ApplicationSettingsSelectors.selectTaxMode);

    if (!billView || billView.length === 0) {
        return null;
    }

    const hasErrors = !!errors;

    return (
        <>
            <Typography variant="h3" className={classes.title}>Bills</Typography>
            <Table aria-label="spanning table" size="small">
                <TableHead>
                    <TableRow>
                        <TableCell className={classes.expandCell} />
                        <TableCell className={classes.indexCell}>#</TableCell>
                        <TableCell className={classes.dateCell} >Date</TableCell>
                        <TableCell>Account</TableCell>
                        <TableCell>Supplier</TableCell>
                        <TableCell className={classes.referenceCell}>Reference</TableCell>
                        <TableCell className={classes.currencyCell}>Currency</TableCell>
                        <TableCell className={classes.amountCell} align="right">Amount</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        billView?.map((billIndex, index) => {
                            const isError = !!errors ? errors.some(e => !!e.meta && !!e.meta.type && !!e.meta.position && e.meta.type === 'Bill' && e.meta.position === (index + 1).toString()) : false;

                            return (
                                <BillView
                                    key={billIndex}
                                    fileIndex={fileIndex}
                                    billIndex={billIndex}
                                    billPosition={index + 1}
                                    importSuccess={hasErrors && !isError}
                                    importError={hasErrors && isError}
                                />
                            );
                        })
                    }
                    {
                        taxMode === TaxMode.Excluded && (
                            <>
                                <TableRow>
                                    <TableCell className={classes.hiddenCell} colSpan={6} />
                                    <TableCell className={classes.totalCell}>SUBTOTAL</TableCell>
                                    <TableCell className={classes.totalAmountCell} align="right">{AudCurrencyFormatter.format(amount)}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.hiddenCell} colSpan={6} />
                                    <TableCell className={classes.totalCell}>TAX</TableCell>
                                    <TableCell className={classes.totalAmountCell} align="right">{AudCurrencyFormatter.format(tax)}</TableCell>
                                </TableRow>
                            </>
                        )
                    }
                    <TableRow>
                        <TableCell className={classes.hiddenCell} colSpan={6}/>
                        <TableCell className={classes.totalCell}>TOTAL</TableCell>
                        <TableCell className={classes.totalAmountCell} align="right">{AudCurrencyFormatter.format(total)}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </>
    );
}

export default BillViews;


// WEBPACK FOOTER //
// ./src/components/BillsView.tsx